(function iife() {
	"use strict";

	angular.module("dx.webapp.answer").directive("dxSingleMultiChoiceAnswer", singleMultiChoiceAnswerDirective);

	function singleMultiChoiceAnswerDirective() {
		return {
			restrict: "E",
			templateUrl: "tmpl/answer/single-multi-choice-answer-directive.html",
			scope: {
				type: "=",
				alternatives: "=",
				answer: "=",
				showCorrectness: "=?",
				gradingType: "<?",
			},
			controllerAs: "vm",
			controller: "DxSingleMultiChoiceAnswerController",
		};
	}
}());
